<template>
  <v-footer class="d-flex flex-column footer py-3" absolute app>
    <div>
      {{ new Date().getFullYear() }} {{ brand }}&#8482;. All Rights Reserved.
      v{{ version }}
    </div>
    <div>
      <a :href="getLink('privacy_request')" target="_blank" class="mx-1">
        Your Privacy Choices
      </a>
      |
      <a :href="getLink('privacy')" target="_blank" class="mx-1">
        Privacy Policy
      </a>
      |
      <a :href="getLink('cookies')" target="_blank" class="mx-1">
        Cookie Policy
      </a>
      |
      <a :href="getLink('ccpa')" target="_blank" class="mx-1">
        CA Collection Notice
      </a>
    </div>
  </v-footer>
</template>

<script>
import { userTierMixin } from "@/mixins/UserTier";
import { getLink } from "@/helpers/links";

export default {
  name: "PlatformFooter",
  mixins: [userTierMixin],
  data: () => ({
    version: import.meta.env.VITE_VERSION,
  }),
  computed: {
    brand() {
      return this.platformTheme === "deeproot"
        ? `${this.themeBrand} Analytics`
        : this.themeBrand;
    },
  },
  methods: {
    getLink,
  },
};
</script>

<style lang="scss" scoped>
@media print {
  .footer {
    min-height: 175px !important;
  }
}
.footer {
  font-family: Barlow, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: center;
  background-color: rgb(var(--v-theme-background));
  color: rgb(var(--v-theme-prominent));
  border-top: 1px solid rgb(var(--v-theme-prominent-lighten-5));
  a {
    color: rgb(var(--v-theme-primary));
    text-decoration: none;
  }
  a:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
}
</style>
